// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__34W_n","info":"UpdateTermsInfo_info__2A3Ad"};